angular.module('onboarding.constants', [])

.constant('appConfig', {appVersion:'0202584432'})

;